module.exports = __webpack_public_path__ + "static/media/desktop12.3fc5726f.png";